<template>
    <el-col :span="4" :lg="6" :push="1">
        <el-dialog width="650" title="Invoice Payment Sample Data" :visible="dialogTableVisible" @close="$emit('onClose')">
            <el-table :data="gridData">
                <el-table-column property="invoiceNumber" label="Invoice Number" width="130"></el-table-column>
                <el-table-column property="accountCode" label="Account Code" width="130"></el-table-column>
                <el-table-column property="amount" label="Amount" width="80"></el-table-column>
                <el-table-column property="reference" label="Reference" width="130"></el-table-column>
                <el-table-column property="paymentDate" label="Payment Date" width="130"></el-table-column>
            </el-table>
            <div style="text-align: center">
                <p>Invoice payment date format should be <b>MM/dd/yyyy</b> format. You can download sample file <a href="https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Invoice_Payment_Import_Template.csv">here</a> </p>
            </div>
        </el-dialog>
    </el-col>
</template>


<script>
    export default {
        props: {
            dialogTableVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                gridData: [
                    {
                        invoiceNumber: 'INV0001',
                        accountCode: '100',
                        amount: '250',
                        reference: 'Payment Reference 1',
                        paymentDate: '01/30/2019'
                    },
                    {
                        invoiceNumber: 'INV0001',
                        accountCode: '100',
                        amount: '250',
                        reference: 'Payment Reference 2',
                        paymentDate: '01/30/2019'
                    },
                    {
                        invoiceNumber: 'INV0002',
                        accountCode: '2100',
                        amount: '1500',
                        reference: 'Payment Reference 3',
                        paymentDate: '01/30/2019'
                    },
                    {
                        invoiceNumber: 'INV0002',
                        accountCode: '2100',
                        amount: '1000',
                        reference: 'Payment Reference 4',
                        paymentDate: '01/30/2019'
                    }
                ],
                dialogFormVisible: false
            };
        }
    };
</script>


// WEBPACK FOOTER //
// InvoicePaymentPopup.vue?59856868